import { Pagination } from '@mui/material';
import styled, { css } from 'styled-components';
import { colors } from '../../../utils/colors';

export const PaginationComponent = styled(Pagination)`
  @media (max-width: 768px) {
    .MuiPagination-ul {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .Mui-selected {
    color: ${colors.branco};
    background-color: ${colors.verde} !important;
  }
`;

export const ComponentButtonDiv = styled.div`
  display: flex;
`;

export const ButtonComponent = styled.button<{ secundary?: boolean }>`
  color: ${colors.branco10};
  background-color: ${colors.verde};
  border: 1px solid ${colors.verde};
  width: 130px;
  height: 42px;
  border-radius: 20px;
  cursor: pointer;
  transition: ease-in-out 250ms;
  margin-right: 15px;

  ${(props) =>
    props.secundary &&
    css`
      background-color: ${colors.branco};
      color: ${colors.verde};

      &:hover {
        background-color: ${colors.cinza20};
      }
    `}

  &:hover {
    background: ${colors.branco};
    color: ${colors.verde};
  }
`;
